<template>
  <v-container style="max-width:1000px">
    <h1>Kirjautuminen</h1>
    <v-text-field
      v-model="user"
      type="text"
      outlined
      dense
      hide-details
    />
    <v-text-field
      v-model="password"
      type="password"
      outlined
      dense
      hide-details
    />
    <v-btn @click="login()">
      Kirjaudu
    </v-btn>
  </v-container>
</template>

<script>
import { apiPost } from '../api';

export default {
  data: () => ({
    user: '',
    password: '',
  }),
  computed: {
    companyId() {
      return this.$route.params.companyId;
    },
  },
  methods: {
    async login() {
      const response = await apiPost(`authorization/login/${this.companyId}`, { user: this.user, password: this.password });
      console.warn(response);
    },
  },
};
</script>
